/**
 * Pluralize a string based on a given count.
 * Note: This will need revised for i18n.
 */
export const pluralize = (count: number | undefined, singular: string) => {
  return count === 1 ? singular : `${singular}s`;
};
